module.exports = __webpack_public_path__ + "img/Intranet_Head2__3.965d917f.png";